module.exports = __webpack_public_path__ + "img/DieEinsamkeitDesLangstreckenläufers.ec997961.jpg";